import PropTypes from 'prop-types';
import React from 'react';
import { useCommunities } from '../../Communities/containers/communitiesDataStore';
import NotAMemberOfAnyCommunityMessage from '../../Communities/NotAMemberOfAnyCommunityMessage/NotAMemberOfAnyCommunityMessage';
import CommunityImage from '../../Community/CommunityImage';
import { useUser } from '../../User/containers/UserDataStore';
import ThreadSummary from '../UI/ThreadSummary';

CommunityOptions.propTypes = {
	threadsByCommunityId: PropTypes.object,
	goToCommunity: PropTypes.func,
};

export default function CommunityOptions({
	threadsByCommunityId,
	goToCommunity,
}) {
	const { getCommunities } = useCommunities();
	const communities = getCommunities();
	const { isAnonymous } = useUser();

	const communityCount = Object.keys(threadsByCommunityId).length;

	const renderCommunityOption = (threads, communityId) => {
		return (
			<div
				onClick={() => goToCommunity(communityId)}
				className="community-option">
				<div className="column">
					<CommunityImage communityId={communityId} dimensions={20} />
				</div>
				<div className="column bold">
					{getCommunityName(communityId)}
				</div>
				{threads && (
					<div className="column-right">
						<ThreadSummary
							threads={threads}
							doIncludeCommunities={false}
						/>
					</div>
				)}
				<div className="clear" />
			</div>
		);
	};

	const renderCommunitiesWithoutThreads = threadsByCommunityId => {
		var communitiesWithoutThreads = communities.filter(
			community =>
				!Object.keys(threadsByCommunityId)
					.map(Number)
					.includes(community.id),
		);
		communitiesWithoutThreads =
			communitiesWithoutThreads &&
			communitiesWithoutThreads.length > 0 &&
			communitiesWithoutThreads.filter(c => c.member && c.name);

		return communitiesWithoutThreads.length && !isAnonymous() ? (
			communitiesWithoutThreads.map(community => (
				<React.Fragment key={community.id}>
					{renderCommunityOption(null, community.id)}
				</React.Fragment>
			))
		) : (
			<div style={{ paddingTop: 10 }}>
				<NotAMemberOfAnyCommunityMessage />
			</div>
		);
	};

	const getCommunityName = communityId => {
		const community = communities.find(
			com => com.id === Number(communityId),
		);
		const communityName = community ? community.name : undefined;
		return communityName;
	};

	return (
		<div className="multiple-community-frame">
			{communityCount > 0 && (
				<div>
					This title has an active conversation in{' '}
					{Object.keys(threadsByCommunityId).length} of your
					communities. Select which you want to see:
				</div>
			)}
			{Object.keys(threadsByCommunityId).map(communityId => (
				<React.Fragment key={communityId}>
					{renderCommunityOption(
						threadsByCommunityId[communityId],
						communityId,
					)}
				</React.Fragment>
			))}
			<div>
				{communityCount === 0 && (
					<span>
						This title has no active conversations in your
						communities.{' '}
					</span>
				)}
				<span>
					To start a conversation about this title in one of your
					other communities, click below...
				</span>
			</div>
			<div>{renderCommunitiesWithoutThreads(threadsByCommunityId)}</div>
		</div>
	);
}
